import ourServicesSchema from './ourServices';
import contactUsSchema from './contactUs';
import faqSchema from './faq';
import usefulLinksSchema from './usefulLinks';
import heroSection from './home/heroSection';
import aboutSection from './home/aboutSection';
import founderSection from './home/founderSection'
import servicesSection from './home/servicesSection'
import testimonialSection from './home/testimonialSection'
import whyChooseUsSection from './home/whyChooseUsSection'
import aboutUsFounderSection from './aboutUs/founderSection'
import aboutUsAboutSection from './aboutUs/aboutSection'
import aboutUsTeamSection from './aboutUs/teamSection'
import aboutUsWhatWeDoSection from './aboutUs/whatWeDoSection'
import faqTitleSection from './faq/titleSection'
import faqGroupSection from './faq/groupsSection'
import faqLinksSection from './faq/linksSection'
import blockContent from './blockContent'
import contactSection from './contactSection'

export const schemaTypes = [
    ourServicesSchema,
    contactUsSchema,
    faqSchema,
    usefulLinksSchema,
    heroSection,
    aboutSection,
    founderSection,
    servicesSection,
    testimonialSection,
    whyChooseUsSection,
    aboutUsFounderSection,
    aboutUsAboutSection,
    aboutUsTeamSection,
    aboutUsWhatWeDoSection,
    faqTitleSection,
    faqGroupSection,
    faqLinksSection,
    blockContent,
    contactSection
];